import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../../assets/sessions/backgrounds/viewpoints-pathways-background.png'
import _imports_1 from '../../assets/sessions/session-3/session-3-tree-text.png'
import _imports_2 from '../../assets/sessions/session-3/curiosity-arrow.png'
import _imports_3 from '../../assets/sessions/session-3/anxiety-arrow.png'
import _imports_4 from '../../assets/sessions/session-3/downlight.png'
import _imports_5 from '../../assets/sessions/session-3/tree-with-outline.png'
import _imports_6 from '../../assets/sessions/session-3/avatar-with-shadow.png'
import _imports_7 from '../../assets/sessions/session-3/telescope.png'
import _imports_8 from '../../assets/sessions/session-3/tree-in-telescope.png'
import _imports_9 from '../../assets/sessions/session-3/reflection.png'
import _imports_10 from '../../assets/sessions/session-3/viewpoints-speech-bubble.png'
import _imports_11 from '../../assets/sessions/session-3/avatar-white-with-shadow.png'
import _imports_12 from '../../assets/sessions/session-3/avatar-white.png'
import _imports_13 from '../../assets/sessions/viewpoints-report-sample.png'
import _imports_14 from '../../assets/sessions/session-3/empty-viewpoints-head.png'
import _imports_15 from '../../assets/sessions/session-3/who-viewpoints-text.png'
import _imports_16 from '../../assets/sessions/session-3/who-arrow.png'
import _imports_17 from '../../assets/sessions/session-3/exemplar-viewpoints-1.png'
import _imports_18 from '../../assets/sessions/session-3/exemplar-viewpoints-2.png'
import _imports_19 from '../../assets/sessions/session-3/exemplar-viewpoints-3.png'
import _imports_20 from '../../assets/sessions/steps.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "session-background session-background-viewpoints-invite" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "session background"
  })
], -1)
const _hoisted_2 = { class: "background-visuals" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"width":"100%","left":"0","top":"0"},
  alt: ""
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  style: {"width":"50%","left":"24%","bottom":"23%"},
  alt: ""
}, null, -1)
const _hoisted_5 = {
  ref: "speechBubbleAvatarImage",
  src: _imports_11,
  style: {"width":"6%","left":"58%","top":"55%"},
  alt: ""
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text-darken session-wide-only" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_13,
  alt: "Sample Viewpoints Report Cover",
  style: {"width":"60%","margin":"0 auto"}
}, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  ref: "whoTextImage",
  src: _imports_15,
  style: {"width":"65%","left":"20%","top":"25%"},
  alt: ""
}
const _hoisted_11 = {
  ref: "exemplarsInitialImage",
  src: _imports_17,
  style: {"width":"60%","left":"20%","top":"20%"},
  alt: ""
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_20,
  alt: "Sample Viewpoints Report Cover",
  style: {"width":"80%","margin":"0 auto"}
}, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  ref: "textWrapper",
  class: "text-wrapper"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  id: "slide0",
  class: "slide-wrapper spacer-slide"
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Your Solo report depicts how you see yourself."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" But do others see you in the same way? Why not find out by doing your Gyre Viewpoints? ")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, "It’s a quick and easy process!", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h2", null, "Our Viewpoints Philosophy", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, " As human beings we have two instincts that are often in tension with each other. On the one hand, we are curious to know how others see us, yet on the other hand, we tend to be anxious about other people evaluating us negatively. The net effect is that feedback can be hard to come by, yet it is like oxygen for development. ", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, " In creating Gyre Viewpoints we want to build your curiosity and minimise your anxiety. ", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h3", null, "Points of view", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", null, " We chose the title Viewpoints carefully because we want to reflect the fact that we are all curious to know how others see us, and whether they see the same person in us as we see in ourselves. It is about their point of view on you: it is neither right nor wrong, and typically will tell you as much about them as it will about you. ", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h3", null, "Strength-based", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", null, " Many people have experienced ‘360 feedback’ and found it to be an unhelpful experience. It often leaves people feeling evaluated and becomes about fault-finding. ", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", null, " The way Viewpoints scores are calculated means that everyone (whether experienced CEO or current student) will have 5 most characteristic strengths and 5 least characteristic strengths in their report. ", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", null, " It is about how people see the pattern of your strengths, not whether they think you are better or worse than another person. ", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h3", null, "Not anonymous", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", null, " Other 360 processes are typically anonymous, with the belief that it will be more “truthful”. However, if website and social media comments are anything to go by, anonymity is often unhelpful. It gets in the way of people having conversations. ", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", null, " In Viewpoints the headline view from each of your respondents is attributable. You will get to see how each of them see your 2 best-fit and 2 least-fit Leader types. ", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", null, " We also make it easy for your respondents to share their full report with you so that you both can have a rich conversation picking through the detail of how they see your strengths and leadership. ", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", null, " Viewpoints combines the positives of truthful, attributable feedback on your relative strengths and gaps without the crushing negatives of harmful comments or league table popularity polls. ", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("h3", null, "People can be as anxious giving feedback as receiving it", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", null, " We have also thought hard about creating a really positive experience for people offering their point of view to you. ", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", null, " Comments from our users giving their Viewpoints feedback are that they find the experience engaging and thought-provoking, often helping them see the individual in a new light. ", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", null, " If you want to get an idea of what your Viewpoints report will look like, use this link to see a sample report: ", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("h2", null, "Who to turn to for feedback", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", null, " Turn to people whose opinion and views you value. They can be current colleagues, your boss, former colleagues, partners. But also think about family and friends. ", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", null, " The aim is to understand how people see you and what is at the core of your character. Don’t be surprised if different people or groups of people see you in different ways! ", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("p", null, " Invite more people rather than fewer. If you get just 3 or 4 Viewpoints, the patterns can be hard to see, particularly if you have got feedback from different parts of your life, personal and professional. ", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", null, " Typically, you will want at least 6 responses, so anticipate connecting with 10 or more people to invite their involvement. ", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", null, " Once you have made your invitations, Gyre will help you keep track of who has responded. It’s very straightforward to send a reminder to anyone who forgot to complete. Gyre will automatically update your report as you get more data. ", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", null, " Unlike traditional 360 feedback systems, your Viewpoints functionality remains ‘live’ for as long as you have full membership. ", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("p", null, " This means you can add further respondents at any point and there is no upper limit to how many people you can invite. It also means that you can return and repeat Viewpoints at any stage through your membership. ", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("h2", null, "Invite", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("p", null, " Type in the names or email addresses of people you want feedback from. If they are already registered, their email address will automatically fill out. ", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" You can always invite more later from your "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/home?view=MyDashboard",
    target: "_blank"
  }, "My Dashboard page"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("h3", null, "Next steps", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("p", null, null, -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("p", null, " As your respondents complete their feedback for you, you’ll receive notifications from us, so you know when to log back in. ", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("p", null, " You’ll need to wait until you have at least two viewpoints responses before you can access your Viewpoints report. ", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("p", null, " Once your Viewpoints report is ready, we advise you complete the ‘Working with Your Viewpoints Report’ pathway as this will guide you through the key insights to be gained from your report. ", -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("p", null, "Until then!", -1)
const _hoisted_53 = { class: "cta-button-wrapper" }

import { ComponentPublicInstance, getCurrentInstance, onMounted, onUnmounted, ref } from "vue";
import { Power0, Power2, Power4, Back, TimelineMax, TweenLite } from "gsap";
import * as ScrollMagic from "scrollmagic";
import Debug from "debug";
import imagesLoadedDirective from "../../directives/images-loaded";

import { InviteControlApiModel, SessionsApiModel } from "../../api-models";
import SessionWrapper from "../../components/sessions/session-wrapper.vue";
import SessionSlide from "../../components/sessions/session-slide.vue";
import { SessionLayoutType } from "../../components/sessions/session-animation-controller";
import HomeNavigation from "../../components/sessions/home-navigation.vue";
import TitleVisuals from "../../components/sessions/title-visuals.vue";
import InviteControl from "../../components/invite-control/invite-control.vue";
import TreeVisual from "../../components/sessions/tree-visual.vue";
import AbsoluteVisual from "../../components/sessions/absolute-visual.vue";
import { SessionIds } from "../../components/sessions/session-models";
import SessionInstanceState from "../../components/sessions/session-instance-state";
import useSessionBase from "../../composables/useSessionBase";
import useNotification, { CompletionNotification } from "../../composables/useNotification";
import { csContext } from "../../services/cs-context";
import viewpointsSessionLinkResourceIds from "../../services/cms/viewpoints-session-link-resource-ids";

const sampleViewpointsReportUrl =
  "https://app.gyreteams.com/sharedreport/J7FjaaBFwb7TIpv/viewpoints-report-for-vicky-hope";


export default /*#__PURE__*/_defineComponent({
  __name: 'viewpoints-pathway',
  props: {
    sessionsModel: {},
    inviteControlModel: {}
  },
  setup(__props: any, { expose: __expose }) {

const debug = Debug("cs.Session3ViewpointsInvite");

const props = __props;

const vImagesLoaded = imagesLoadedDirective;

// eslint-disable-next-line @typescript-eslint/no-var-requires
const titleLogoSrc = ref(require("../../assets/sessions/jyranians-facing.png"));

const hasFinishedInviting = ref<boolean>(
  SessionInstanceState.withStore("hasFinishedInviting", false),
);

function getSessionId(): string {
  return SessionIds.ViewpointsInvite;
}

const instance = getCurrentInstance()?.proxy as ComponentPublicInstance;

const {
  isInline,
  hasCompletedSession,
  initializeAfterImagesLoaded,
  initialize,
  initializeAnimations,
  isLoading,
  handleCloseSession,
  handleKeyDown,
  layoutType,
  titleTimescale,
  loadAnimations,
  scene,
  element,
  classScene,
  destroyed,
  getSessionVersion,
  animations,
} = useSessionBase(getSessionId, instance);

function unlockNextSteps(): void {
  hasFinishedInviting.value = true;
  TweenLite.set(element("#next-steps"), { "max-height": "unset" });
}

function onKeyDown(event: KeyboardEvent): void {
  handleKeyDown(event);
}

onUnmounted(() => {
  document.removeEventListener("keydown", onKeyDown);
  SessionInstanceState.set("hasFinishedInviting", hasFinishedInviting.value);
  destroyed();
});

function closeSession(): void {
  handleCloseSession();
}

function onImagesLoaded(): void {
  initializeAfterImagesLoaded();
}

function onInviteAction(): void {
  if (!hasFinishedInviting.value) {
    unlockNextSteps();
  }
}

// Visual element refs
const homeNavigation = ref();
const titleVisuals = ref();
const darkBackgroundVisual = ref();
const forestTopBackgroundVisual = ref();
const forestBottomBackgroundVisual = ref();
const treeOuter = ref();
const curiosityArrowImage = ref();
const anxietyArrowImage = ref();
const treeTextVisual = ref();
const initialAvatarVisual = ref();
const initialAvatarImage = ref();
const treeInner = ref();
const telescopeImage = ref();
const telescopeVisual = ref();
const treeInTelescopeVisual = ref();
const whiteOvalWrapper = ref();
const treeInTelescopeImage = ref();
const reflectionImage = ref();
const viewpointsSpeechBubbleImage = ref();
const speechBubbleAvatarVisual = ref();
const speechBubbleNotch = ref();
const crowdVisual = ref();
const crowdOneImage = ref();
const crowdTwoImage = ref();
const crowdThreeImage = ref();
const downlightVisual = ref();
const downlightImage = ref();
const treeWithOutlineVisual = ref();
const sampleReportVisual = ref();
const whoVisual = ref();
const emptyViewpointsHeadImage = ref();
const whoArrowFriends = ref();
const whoArrowFamily = ref();
const whoArrowCurrentColleagues = ref();
const whoArrowFormerColleagues = ref();
const exemplarsVisual = ref();
const exemplarsExtraImage = ref();
const exemplarsExtraCenterImage = ref();
const leftShutter = ref();
const rightShutter = ref();
const inviteControlWrapper = ref();
const shuttersVisual = ref();
const nextStepVisual = ref();

loadAnimations.value = () => {
  const defaultTriggerPosition = isInline.value ? 1 : 0.3;
  const postDarkTriggerPosition = isInline.value ? defaultTriggerPosition : 0.5;
  const defaultEase = Power2.easeInOut;
  TweenLite.defaultEase = defaultEase;

  const timescale = 0.5;
  document.addEventListener("keydown", onKeyDown);
  // document.addEventListener("wheel", this.onWheel);

  const titleTriggerHookPosition = isInline.value ? 0.98 : 1;

  const titleVisualEase = isInline.value ? Power0.easeNone : Power2.easeOut; // Fade out linearly (with scroll position) when inline
  const titleTextEase = isInline.value ? Power4.easeOut : Power4.easeOut; // Fade out quickly when inline to avoid overlaying

  const titleTimeline = () => {
    const tl = new TimelineMax({ paused: true });

    (homeNavigation.value as any).colorSwitch(tl);
    (titleVisuals.value as InstanceType<typeof TitleVisuals>).rollIn(tl, false);

    tl.to(
      element("expectations"),
      titleTimescale * 0.3,
      { autoAlpha: 1, ease: titleVisualEase },
      0,
    );

    return tl;
  };

  // Pre-hide light/dark transition SessionSlides
  TweenLite.set(element("#philosophy"), { autoAlpha: 0.3 });
  TweenLite.set(element("#next-steps"), { autoAlpha: 0.3 });

  const titleScene = new ScrollMagic.Scene({
    triggerElement: element("expectations-inner"),
    triggerHook: titleTriggerHookPosition,
  });

  animations.value!.linkAnimationToScene(
    "title",
    titleTimeline,
    titleScene,
    undefined,
    element("expectations"),
  );

  scene("#philosophy", (tl) => {
    tl.to(darkBackgroundVisual.value, timescale, { autoAlpha: 1 }, 0);
    tl.fromTo(forestTopBackgroundVisual.value, timescale, { left: "-100%" }, { left: "0%" }, 0);
    tl.fromTo(forestBottomBackgroundVisual.value, timescale, { left: "100%" }, { left: "0%" }, 0);
    tl.to(element("#expectations"), timescale, { autoAlpha: 0.1 }, 0);
    (titleVisuals.value as InstanceType<typeof TitleVisuals>).sessionLogoRotateOut(tl);
    (homeNavigation.value as any).colorRevert(tl);
    tl.to(
      (treeOuter.value as InstanceType<typeof AbsoluteVisual>).$el,
      timescale,
      { autoAlpha: 1 },
      0,
    );
    tl.fromTo(curiosityArrowImage.value, timescale, { rotation: -120 }, { rotation: 0 }, 0);
    tl.fromTo(anxietyArrowImage.value, timescale, { rotation: -120 }, { rotation: 0 }, 0);
    tl.to(treeTextVisual.value, timescale, { autoAlpha: 1 }, 0);
    tl.to(
      (initialAvatarVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      timescale,
      { autoAlpha: 1 },
      0,
    );
    tl.to(element("#philosophy"), timescale / 2, { autoAlpha: 1 }, 0);
    tl.to(element("#sample-report"), 0, { autoAlpha: 0 }, 0); // Pre-hide the post-dark slide
  });

  scene("#points-of-view", (tl) => {
    tl.to(
      (treeOuter.value as InstanceType<typeof AbsoluteVisual>).$el,
      timescale,
      { autoAlpha: 0 },
      0,
    );
    tl.to(initialAvatarImage.value, timescale, { left: "15%", scale: 1.7 }, 0);
    tl.to(treeInner.value, timescale, { x: "+20%", y: "-20%", scale: 0.6, autoAlpha: 0 }, 0);
    tl.fromTo(telescopeImage.value, timescale, { top: "100%" }, { top: "52%" }, 0);
    tl.to(
      (telescopeVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      timescale,
      { autoAlpha: 1 },
      0,
    );
    tl.fromTo(
      (treeInTelescopeVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      timescale,
      { scale: 0.5, autoAlpha: 0 },
      { scale: 1, autoAlpha: 1 },
      0,
    );
  });

  scene("#strength-based", (tl) => {
    tl.to(
      (telescopeVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      timescale * 2,
      { autoAlpha: 0 },
      0,
    );
    tl.to(initialAvatarImage.value, timescale * 2, { left: "28%", scale: 2.1 }, 0);
    tl.to(
      whiteOvalWrapper.value,
      timescale * 2,
      {
        left: "30%",
        top: "35%",
        scaleX: 0.55,
        borderColor: "orange",
        borderWidth: 5,
      },
      0,
    );
    tl.to(treeInTelescopeImage.value, timescale * 2, { autoAlpha: 0 }, 0);
    tl.to(reflectionImage.value, timescale * 2, { autoAlpha: 1 }, 0);
  });

  scene("#not-anonymous", (tl) => {
    tl.to(
      whiteOvalWrapper.value,
      timescale * 2,
      { left: "30%", top: "25%", scaleX: 0.5, scaleY: 0.5, borderWidth: 0 },
      0,
    );
    tl.to(reflectionImage.value, timescale, { autoAlpha: 0 }, 0);
    tl.to(viewpointsSpeechBubbleImage.value, timescale, { autoAlpha: 1 }, timescale);
    tl.to(
      (speechBubbleAvatarVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      timescale,
      { autoAlpha: 1 },
      timescale,
    );
    tl.to(speechBubbleNotch.value, timescale * 2, { autoAlpha: 1, bottom: "5%", right: "12%" }, 0);
  });

  scene("#anxious", (tl) => {
    tl.to(
      (treeInTelescopeVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      timescale,
      { autoAlpha: 0 },
      0,
    );
    tl.to(whiteOvalWrapper.value, timescale, { autoAlpha: 0 }, 0);
    tl.to(
      (speechBubbleAvatarVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      timescale,
      { autoAlpha: 0 },
      0,
    );
    tl.to((crowdVisual.value as InstanceType<typeof AbsoluteVisual>).$el, 0.1, { autoAlpha: 1 }, 0);
    tl.to(crowdOneImage.value, timescale, { right: "20%", ease: Back.easeOut }, 0);
    tl.to(crowdTwoImage.value, timescale, { right: "10%", ease: Back.easeOut }, timescale * 0.1);
    tl.to(crowdThreeImage.value, timescale, { right: "6%", ease: Back.easeOut }, timescale * 0.15);
    tl.to(
      (downlightVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      timescale,
      { autoAlpha: 1 },
      0,
    );
    tl.fromTo(downlightImage.value, timescale, { bottom: "100%" }, { bottom: "23%" }, 0);
    tl.to(
      (treeWithOutlineVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      timescale / 2,
      { autoAlpha: 1 },
      timescale / 2,
    );
    tl.to(initialAvatarImage.value, timescale, { left: "40%", scale: 0.9 }, 0);
  });

  scene("#sample-report", (tl) => {
    tl.to((crowdVisual.value as InstanceType<typeof AbsoluteVisual>).$el, 0.1, { autoAlpha: 0 }, 0);
    tl.to(
      (initialAvatarVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      0.1,
      { autoAlpha: 0 },
      0,
    );
    tl.to(
      (downlightVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      0.1,
      { autoAlpha: 0 },
      0,
    );
    tl.to(
      (treeWithOutlineVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      0.1,
      { autoAlpha: 0 },
      0,
    );
    tl.fromTo(
      sampleReportVisual.value,
      timescale,
      { autoAlpha: 0, scale: 0.8 },
      { autoAlpha: 1, scale: 1 },
      0,
    );
    tl.to(forestTopBackgroundVisual.value, timescale, { left: "-100%" }, 0);
    tl.to(forestBottomBackgroundVisual.value, timescale, { left: "100%" }, 0);
    tl.to(darkBackgroundVisual.value, timescale, { autoAlpha: 0 }, 0);
    (homeNavigation.value as any).colorSwitch(tl);
    tl.to(element("#anxious"), timescale / 2, { autoAlpha: 0.1 }, 0);
    tl.to(element("#sample-report"), timescale / 2, { autoAlpha: 1 }, 0);
  });

  scene("#who-to-ask", (tl) => {
    tl.to(sampleReportVisual.value, timescale, { autoAlpha: 0, scale: 0.8 }, 0);
    tl.to(
      (whoVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      timescale,
      { autoAlpha: 1 },
      0,
    );
    tl.fromTo(emptyViewpointsHeadImage.value, timescale, { left: "42%" }, { left: "40%" }, 0);
    tl.fromTo(whoArrowFriends.value, timescale, { rotation: -180 }, { rotation: 0 }, 0);
    tl.fromTo(whoArrowFamily.value, timescale, { rotation: -90 }, { rotation: 90 }, 0);
    tl.fromTo(whoArrowCurrentColleagues.value, timescale, { rotation: 0 }, { rotation: 180 }, 0);
    tl.fromTo(whoArrowFormerColleagues.value, timescale, { rotation: 90 }, { rotation: 270 }, 0);
  });

  scene("#how-many", (tl) => {
    tl.to(
      (whoVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      timescale,
      { autoAlpha: 0 },
      0,
    );
    tl.to(whoArrowFriends.value, timescale, { rotation: 180 }, 0);
    tl.to(whoArrowFamily.value, timescale, { rotation: 270 }, 0);
    tl.to(whoArrowCurrentColleagues.value, timescale, { rotation: 360 }, 0);
    tl.to(whoArrowFormerColleagues.value, timescale, { rotation: 420 }, 0);
    tl.to(
      (exemplarsVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      timescale,
      { autoAlpha: 1 },
      0,
    );
  });

  scene("#remains-live", (tl) => {
    tl.to(exemplarsExtraImage.value, timescale * 2, { autoAlpha: 1 }, 0);
    tl.to(exemplarsExtraCenterImage.value, timescale * 2, { autoAlpha: 1 }, 0);
  });

  scene("#invite", (tl) => {
    tl.to(
      (exemplarsVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      timescale,
      { autoAlpha: 0 },
      0,
    );
    tl.to(
      (shuttersVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      0.1,
      { autoAlpha: 1 },
      0,
    );
    tl.fromTo(leftShutter.value, timescale * 1.5, { left: "-50%" }, { left: "0" }, 0);
    tl.fromTo(rightShutter.value, timescale * 1.5, { left: "100%" }, { left: "50%" }, 0);
    tl.to(
      inviteControlWrapper.value,
      timescale,
      { autoAlpha: 1, className: "+=clickable" },
      timescale * 1.5,
    );
  });

  scene("#next-steps", (tl) => {
    tl.to(
      (shuttersVisual.value as InstanceType<typeof AbsoluteVisual>).$el,
      timescale,
      { autoAlpha: 0 },
      0,
    );
    tl.to(inviteControlWrapper.value, timescale / 2, { autoAlpha: 0, className: "-=clickable" }, 0);
    tl.fromTo(
      nextStepVisual.value,
      timescale,
      { autoAlpha: 0, scale: 0.8 },
      { autoAlpha: 1, scale: 1 },
      0,
    );
    tl.to(element("#next-steps"), timescale / 2, { autoAlpha: 1 }, 0);
  });
};

// TODO: review, is this correct? Is this a general notification or a completed notification that
// needs to be triggered upon an action?
// TODO: speak to Victoria about when to trigger this.
function triggerNotification(): void {
  const { createCompletionNotification } = useNotification();

  const teamId = csContext.currentTeam?.id;

  if (!teamId) {
    return;
  }

  const notification: CompletionNotification = {
    userId: csContext.user.id,
    teamId,
    prismicDoc: null,
    linkResourceId: viewpointsSessionLinkResourceIds.viewpointsInvite,
    linkResourceName: "Viewpoints invite",
  };

  createCompletionNotification(notification);
}

onMounted(() => {
  initialize(props.sessionsModel);
  if (
    props.inviteControlModel.userTags.length > 0 ||
    hasCompletedSession.value ||
    hasFinishedInviting.value
  ) {
    unlockNextSteps();
  }

  initializeAnimations();
  // triggerNotification();
});

__expose({
  isLoading,
  getSessionId,
  getSessionVersion,
  classScene,
  isInline,
});

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    ref: "session",
    class: _normalizeClass(["session session-3-viewpoints-invite-pathway", {
      'session-inline': _unref(layoutType) === _unref(SessionLayoutType).Inline,
      'session-wide': _unref(layoutType) === _unref(SessionLayoutType).Wide,
      'loading': _unref(isLoading),
      'finished-inviting': hasFinishedInviting.value,
    }])
  }, [
    _hoisted_1,
    _createVNode(HomeNavigation, {
      ref_key: "homeNavigation",
      ref: homeNavigation
    }, null, 512),
    _createVNode(TitleVisuals, {
      ref_key: "titleVisuals",
      ref: titleVisuals,
      "session-title": "Viewpoints",
      "session-logo-image-src": titleLogoSrc.value
    }, null, 8, ["session-logo-image-src"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AbsoluteVisual, {
        ref_key: "treeOuter",
        ref: treeOuter
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            ref_key: "treeInner",
            ref: treeInner,
            class: "tree-inner",
            style: {"width":"44%","left":"28%","top":"19%"}
          }, [
            _createVNode(TreeVisual, {
              ref: "treeVisual",
              class: "something-else"
            }, null, 512)
          ], 512),
          _hoisted_3,
          _createElementVNode("img", {
            ref_key: "curiosityArrowImage",
            ref: curiosityArrowImage,
            src: _imports_2,
            style: {"width":"35%","left":"11%","top":"37%"},
            alt: ""
          }, null, 512),
          _createElementVNode("img", {
            ref_key: "anxietyArrowImage",
            ref: anxietyArrowImage,
            src: _imports_3,
            style: {"width":"21%","left":"68%","top":"18%"},
            alt: ""
          }, null, 512)
        ]),
        _: 1
      }, 512),
      _createElementVNode("div", {
        ref_key: "treeTextVisual",
        ref: treeTextVisual,
        class: "visual side-visual"
      }, null, 512),
      _createVNode(AbsoluteVisual, {
        ref_key: "downlightVisual",
        ref: downlightVisual
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            ref_key: "downlightImage",
            ref: downlightImage,
            src: _imports_4,
            style: {"width":"40%","left":"30%","bottom":"23%"},
            alt: ""
          }, null, 512)
        ]),
        _: 1
      }, 512),
      _createVNode(AbsoluteVisual, {
        ref_key: "treeWithOutlineVisual",
        ref: treeWithOutlineVisual
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 512),
      _createVNode(AbsoluteVisual, {
        ref_key: "initialAvatarVisual",
        ref: initialAvatarVisual
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            ref_key: "initialAvatarImage",
            ref: initialAvatarImage,
            src: _imports_6,
            alt: "Gyre Avatar",
            style: {"width":"4%","left":"40%","top":"63%"}
          }, null, 512)
        ]),
        _: 1
      }, 512),
      _createVNode(AbsoluteVisual, {
        ref_key: "telescopeVisual",
        ref: telescopeVisual
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            ref_key: "telescopeImage",
            ref: telescopeImage,
            src: _imports_7,
            style: {"width":"18%","left":"20%","top":"52%"},
            alt: ""
          }, null, 512)
        ]),
        _: 1
      }, 512),
      _createVNode(AbsoluteVisual, {
        ref_key: "treeInTelescopeVisual",
        ref: treeInTelescopeVisual
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            ref_key: "whiteOvalWrapper",
            ref: whiteOvalWrapper,
            style: {"width":"40%","height":"40%","left":"50%","top":"18%","background-color":"white","border-radius":"50%","border":"2px solid rgba(0, 0, 0, 0.7)"}
          }, [
            _createElementVNode("img", {
              ref_key: "treeInTelescopeImage",
              ref: treeInTelescopeImage,
              src: _imports_8,
              style: {"position":"absolute","width":"100%"},
              alt: ""
            }, null, 512),
            _createElementVNode("img", {
              ref_key: "reflectionImage",
              ref: reflectionImage,
              src: _imports_9,
              style: {"position":"absolute","width":"100%","height":"100%","left":"0","bottom":"0","opacity":"0"},
              alt: ""
            }, null, 512),
            _createElementVNode("img", {
              ref_key: "viewpointsSpeechBubbleImage",
              ref: viewpointsSpeechBubbleImage,
              src: _imports_10,
              style: {"position":"absolute","width":"90%","height":"90%","left":"5%","bottom":"5%","opacity":"0"},
              alt: ""
            }, null, 512),
            _createElementVNode("div", {
              ref_key: "speechBubbleNotch",
              ref: speechBubbleNotch,
              class: "speech-bubble-notch"
            }, null, 512)
          ], 512)
        ]),
        _: 1
      }, 512),
      _createVNode(AbsoluteVisual, {
        ref_key: "speechBubbleAvatarVisual",
        ref: speechBubbleAvatarVisual
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", _hoisted_5, null, 512)
        ]),
        _: 1
      }, 512),
      _createVNode(AbsoluteVisual, {
        ref_key: "crowdVisual",
        ref: crowdVisual
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            ref_key: "crowdOneImage",
            ref: crowdOneImage,
            src: _imports_12,
            style: {"width":"3%","right":"-10%","top":"65%"},
            alt: ""
          }, null, 512),
          _createElementVNode("img", {
            ref_key: "crowdTwoImage",
            ref: crowdTwoImage,
            src: _imports_12,
            style: {"width":"3%","right":"-10%","top":"68%"},
            alt: ""
          }, null, 512),
          _createElementVNode("img", {
            ref_key: "crowdThreeImage",
            ref: crowdThreeImage,
            src: _imports_12,
            style: {"width":"3%","right":"-10%","top":"66%"},
            alt: ""
          }, null, 512)
        ]),
        _: 1
      }, 512),
      _createElementVNode("div", {
        ref_key: "forestTopBackgroundVisual",
        ref: forestTopBackgroundVisual,
        class: "visual forest-top-background-visual transitioned show"
      }, null, 512),
      _createElementVNode("div", {
        ref_key: "forestBottomBackgroundVisual",
        ref: forestBottomBackgroundVisual,
        class: "visual forest-bottom-background-visual transitioned show"
      }, null, 512),
      _createElementVNode("div", {
        ref_key: "darkBackgroundVisual",
        ref: darkBackgroundVisual,
        class: "visual dark-background-visual"
      }, _hoisted_7, 512),
      _createElementVNode("div", {
        ref_key: "sampleReportVisual",
        ref: sampleReportVisual,
        class: "visual side-visual visual-with-dark-drop-shadow"
      }, _hoisted_9, 512),
      _createVNode(AbsoluteVisual, {
        ref_key: "whoVisual",
        ref: whoVisual
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            ref_key: "emptyViewpointsHeadImage",
            ref: emptyViewpointsHeadImage,
            src: _imports_14,
            style: {"width":"16%","left":"40%","top":"42%"},
            alt: ""
          }, null, 512),
          _createElementVNode("img", _hoisted_10, null, 512),
          _createElementVNode("img", {
            ref_key: "whoArrowFriends",
            ref: whoArrowFriends,
            src: _imports_16,
            style: {"width":"25%","left":"12%","top":"29%"},
            alt: ""
          }, null, 512),
          _createElementVNode("img", {
            ref_key: "whoArrowFamily",
            ref: whoArrowFamily,
            src: _imports_16,
            style: {"width":"25%","left":"45%","top":"11%","transform":"rotateZ(90deg)"},
            alt: ""
          }, null, 512),
          _createElementVNode("img", {
            ref_key: "whoArrowCurrentColleagues",
            ref: whoArrowCurrentColleagues,
            src: _imports_16,
            style: {"width":"25%","left":"64%","top":"43%","transform":"rotateZ(180deg)"},
            alt: ""
          }, null, 512),
          _createElementVNode("img", {
            ref_key: "whoArrowFormerColleagues",
            ref: whoArrowFormerColleagues,
            src: _imports_16,
            style: {"width":"25%","left":"24%","top":"62%","transform":"rotateZ(270deg)"},
            alt: ""
          }, null, 512)
        ]),
        _: 1
      }, 512),
      _createVNode(AbsoluteVisual, {
        ref_key: "exemplarsVisual",
        ref: exemplarsVisual
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", _hoisted_11, null, 512),
          _createElementVNode("img", {
            ref_key: "exemplarsExtraImage",
            ref: exemplarsExtraImage,
            src: _imports_18,
            style: {"width":"23%","left":"38.5%","top":"8%","opacity":"0"},
            alt: ""
          }, null, 512),
          _createElementVNode("img", {
            ref_key: "exemplarsExtraCenterImage",
            ref: exemplarsExtraCenterImage,
            src: _imports_19,
            style: {"width":"29.5%","left":"35.3%","top":"34.5%","opacity":"0"},
            alt: ""
          }, null, 512)
        ]),
        _: 1
      }, 512),
      _createVNode(AbsoluteVisual, {
        ref_key: "shuttersVisual",
        ref: shuttersVisual,
        "full-size": true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            ref_key: "leftShutter",
            ref: leftShutter,
            class: "left-shutter",
            style: {"top":"0","left":"0","width":"50%","height":"100%"}
          }, null, 512),
          _createElementVNode("div", {
            ref_key: "rightShutter",
            ref: rightShutter,
            class: "right-shutter",
            style: {"top":"0","left":"50%","width":"50%","height":"100%"}
          }, null, 512)
        ]),
        _: 1
      }, 512),
      _createElementVNode("div", {
        ref_key: "nextStepVisual",
        ref: nextStepVisual,
        class: "visual side-visual"
      }, _hoisted_13, 512)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createVNode(SessionSlide, { id: "expectations" }, {
        text: _withCtx(() => [
          _hoisted_16,
          _hoisted_17
        ]),
        _: 1
      }),
      _createVNode(SessionSlide, {
        id: "philosophy",
        class: "dark-slide"
      }, {
        text: _withCtx(() => [
          _hoisted_18,
          _hoisted_19,
          _hoisted_20
        ]),
        _: 1
      }),
      _createVNode(SessionSlide, {
        id: "points-of-view",
        class: "dark-slide"
      }, {
        text: _withCtx(() => [
          _hoisted_21,
          _hoisted_22
        ]),
        _: 1
      }),
      _createVNode(SessionSlide, {
        id: "strength-based",
        class: "dark-slide"
      }, {
        text: _withCtx(() => [
          _hoisted_23,
          _hoisted_24,
          _hoisted_25,
          _hoisted_26
        ]),
        _: 1
      }),
      _createVNode(SessionSlide, {
        id: "not-anonymous",
        class: "dark-slide"
      }, {
        text: _withCtx(() => [
          _hoisted_27,
          _hoisted_28,
          _hoisted_29,
          _hoisted_30,
          _hoisted_31
        ]),
        _: 1
      }),
      _createVNode(SessionSlide, {
        id: "anxious",
        class: "dark-slide"
      }, {
        text: _withCtx(() => [
          _hoisted_32,
          _hoisted_33,
          _hoisted_34
        ]),
        _: 1
      }),
      _createVNode(SessionSlide, { id: "sample-report" }, {
        text: _withCtx(() => [
          _hoisted_35,
          _createElementVNode("p", { class: "text-center" }, [
            _createElementVNode("a", {
              href: sampleViewpointsReportUrl,
              class: "btn btn-primary btn-lg",
              target: "_blank",
              rel: "noopener noreferrer"
            }, " View sample report ")
          ])
        ]),
        _: 1
      }),
      _createVNode(SessionSlide, { id: "who-to-ask" }, {
        text: _withCtx(() => [
          _hoisted_36,
          _hoisted_37,
          _hoisted_38
        ]),
        _: 1
      }),
      _createVNode(SessionSlide, { id: "how-many" }, {
        text: _withCtx(() => [
          _hoisted_39,
          _hoisted_40,
          _hoisted_41
        ]),
        _: 1
      }),
      _createVNode(SessionSlide, { id: "remains-live" }, {
        text: _withCtx(() => [
          _hoisted_42,
          _hoisted_43
        ]),
        _: 1
      }),
      _createVNode(SessionSlide, { id: "invite" }, {
        text: _withCtx(() => [
          _hoisted_44,
          _hoisted_45,
          _hoisted_46,
          _createElementVNode("div", {
            ref_key: "inviteControlWrapper",
            ref: inviteControlWrapper,
            class: "visual side-visual invite-wrapper"
          }, [
            _createVNode(InviteControl, {
              model: _ctx.inviteControlModel,
              "show-examples": true,
              onInviteAction: onInviteAction
            }, null, 8, ["model"])
          ], 512)
        ]),
        _: 1
      }),
      _createVNode(SessionSlide, {
        id: "next-steps",
        class: "last-slide"
      }, {
        text: _withCtx(() => [
          _hoisted_47,
          _hoisted_48,
          _hoisted_49,
          _hoisted_50,
          _hoisted_51,
          _hoisted_52,
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("a", {
              class: "btn btn-lg btn-primary journey-next-step",
              onClick: closeSession,
              onKeydown: _withKeys(closeSession, ["enter"]),
              "data-test": "complete-viewpoints-pathway"
            }, "Close session", 32)
          ])
        ]),
        _: 1
      })
    ], 512)
  ], 2)), [
    [_unref(vImagesLoaded), onImagesLoaded]
  ])
}
}

})